import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <nav className="footer-links" aria-label="フッターリンク">
          <Link to="/terms">利用規約</Link>
          <span className="divider">|</span>
          <Link to="/legal/specified-commercial-transactions">特定商取引法に基づく表示</Link>
          <span className="divider">|</span>
          <Link to="/privacy">プライバシーポリシー</Link>
          <span className="divider">|</span>
          <Link to="/faq">よくある質問</Link>
          <span className="divider">|</span>
          <Link to="/contact">お問い合わせ</Link>
        </nav>
        <div className="footer-logo-copyright">
          <img
            src="/icons/footerlogo.svg"
            alt="IrieTix ロゴ"
            className="footer-logo-image"
          />
          <span className="footer-copyright-inline">© IRIE TIX All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;